import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';

//Load styles
require("./comp-field.scss");

@autoinject
@transient()
export class CompField {

    @bindable
    public label: string;

    @bindable
    public info: string = "";
}